import React, { useEffect, useMemo, useState } from "react";
import { Drawer, Tabs } from "antd";
import { AddTruckType } from "../../../../enums/AddTruckType";
import ViewMaterial from "./ViewMaterial";
import ViewTruck from "./ViewTruck";
import BidToolForm from "../../CreateJobView/MaterialTruckDetails/TruckDetails/BidToolForm";
import { DrawerHeaderStyle } from "../../../../constants/CustomStyles";
import styles from "./ViewMaterialAndTruck.module.scss"
import Form from "../../../Form";
import { useLocation } from "react-router-dom";
import { appRoutes } from "../../../../constants/appRoutes";
import { getDefaultValues, getEditDefaultValues } from "../../CreateJobView/constants";
import CreateJobServices from "../../../../services/createJob.services";
import { useWrapperContext } from "../../../../context/WrapperContext";
import { useFormContext } from "react-hook-form";
import { PlacementPositions } from "../../../../enums/PlacementPositionsEnums";
import { ViewMaterialAndTruckConstants } from "./constants";

const ViewMaterialAndTruck = ({ jobLeadData }) => {
  const { TabPane } = Tabs;
  const {
    MATERIAL_TAB_NAME,
    TRUCK_TAB_NAME,
    MATERIAL_TAB_KEY,
    TRUCK_TAB_KEY,
    BID_TOOL_HEIGHT,
    BID_TOOL_WIDTH,
  } = ViewMaterialAndTruckConstants;
  const [isBidToolOpen, setIsBidToolOpen] = useState(false);
  const [defaultValues, setDefaultValues] = useState({});

  const handleBidToolOpen = () => setIsBidToolOpen(true);
  const handleBidToolClose = () => setIsBidToolOpen(false);


  const location = useLocation();
  const { FetchSettingsBidConfig } = CreateJobServices();

  const { selectedCustomer, source } = location.state || {};
  const { prevRecord } = useWrapperContext();

  const { data: bidConfigSettingsData } = FetchSettingsBidConfig(undefined);

  const defaultValue = useMemo(() => getDefaultValues(false, "", bidConfigSettingsData), [bidConfigSettingsData]);

  const handleOpenBidToolWithTruckPrice = (record: any) => {
    setDefaultValues(defaultValue => ({
      ...defaultValue,
      truckPrice: record?.truckingPrice,
      truckingCost: record?.truckingCost,
      actualBid: record?.truckingPrice,
    }));
    handleBidToolOpen();
  }

  useEffect(() => {
    setDefaultValues(defaultValue);
  }, [defaultValue])

  return (
    <>
      <>
        <Drawer
          visible={isBidToolOpen}
          placement={PlacementPositions.RIGHT}
          width={BID_TOOL_WIDTH}
          height={BID_TOOL_HEIGHT}
          title={
            <span className={styles.BidToolHeader}>Bid Tool</span>
          }
          onClose={handleBidToolClose}
          destroyOnClose
          headerStyle={DrawerHeaderStyle}
        >
          <Form defaultValues={defaultValues}>
            {() => <BidToolForm isReference={true} />}
          </Form>
        </Drawer>
        <div>
          <Tabs
            swipeable
            tabPosition={PlacementPositions.TOP}
            defaultActiveKey={MATERIAL_TAB_KEY}
          >
            <TabPane
              tab={MATERIAL_TAB_NAME}
              key={MATERIAL_TAB_KEY}
            >
              <ViewMaterial
                materialTruckList={jobLeadData?.material}
                handleOpenBidTool={handleOpenBidToolWithTruckPrice}
              />
            </TabPane>
            <TabPane
              tab={TRUCK_TAB_NAME}
              key={TRUCK_TAB_KEY}
            >
              <ViewTruck
                truckDetails={jobLeadData?.material}
                handleOpenBidTool={handleOpenBidToolWithTruckPrice}
              />
            </TabPane>
          </Tabs>
        </div>
      </>
    </>
  );
};
export default ViewMaterialAndTruck;
